// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Dialog from "../Dialog/Dialog.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function DialogForm(props) {
  let onDismiss = props.onDismiss;
  return <Dialog.make
    className={props.className}
    visible={props.visible}
  >
    <header>
      <h3>
        {props.heading}
      </h3>
    </header>
    {props.children}
    <footer>
      <button
        className={Styles.button.variantPrimary}
        form={props.formId}
        type={"submit"}
      >
        {"Uložit"}
      </button>
      <button
        className={Styles.button.base}
        type={"button"}
        onClick={param => onDismiss()}
      >
        {"Zrušit"}
      </button>
    </footer>
  </Dialog.make>;
}

let make = DialogForm;

export {
  make,
}
/* Dialog Not a pure module */
